import { render, staticRenderFns } from "./Addrescueteamlist.vue?vue&type=template&id=65fb8508&"
import script from "./Addrescueteamlist.vue?vue&type=script&lang=js&"
export * from "./Addrescueteamlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports